import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    message: "domains.application.components.backend-access.backend-access-i18n.message"
};
export const translations = {
    da: {
        message: "Det er ikke lykkedes at forbinde til applikationsserveren. Dette vil ofte skyldes, at der ikke er opsat Microsoft konto på din Advosys konto. Log ind i Advosys med din Microsoft konto for at aktivere denne."
    },
    en: {
        message: "Connection to the application server failed. This is mainly because no Microsoft account has been set up on your Advosys account. Log in to Advosys with your Microsoft Account to activate it."
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        message: t(k.message)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
